import defaultBackground from 'assets/default_explorer-background.png'
import { DatesDisplay, Flex, Image, LocationDisplay, Spacer, Text } from 'components'
import { IPublicEvent } from 'types'

interface Props {
  event: IPublicEvent
  sectionLabel?: string
}

export default function EventHeader({ event, sectionLabel }: Props) {
  const { title, startTime, endTime, location, background, logo } = event || {}
  const backgroundImage = `url(${background || defaultBackground})`

  return (
    <Flex direction="column" zIndex={1}>
      <Flex
        h="210px"
        bgImage={backgroundImage}
        bgSize="cover"
        bgPos="center"
        align="center"
        justify="center"
      >
        {logo && <Image src={logo} alt="Event Logo" objectFit="contain" maxW="60%" />}
      </Flex>
      <Flex
        bgColor="rgba(255, 255, 255, 0.54)"
        backdropFilter="blur(2px)"
        direction="column"
        gap={2}
        p={5}
        pb={2}
        h="135px"
      >
        <Text textStyle="h4" truncate>
          {title}
        </Text>
        <Flex direction="row" alignItems="center" gap={3} opacity={0.6}>
          <DatesDisplay startTime={startTime} endTime={endTime} textProps={{ opacity: 1 }} />
          <LocationDisplay location={location} textProps={{ opacity: 1 }} />
        </Flex>
        <Spacer />
        <Text pl={3} textStyle="bodySmall" fontWeight="normal">
          {sectionLabel}
        </Text>
      </Flex>
    </Flex>
  )
}
